export const TASK_ERROR = "TASK_ERROR";
export const TASK_RESET = "TASK_RESET";
export const GET_TASK = "GET_TASK";
export const GET_TASK_CONTACT = "GET_TASK_CONTACT";
export const EDIT_TASK_SUCCESS = "EDIT_TASK_SUCCESS";
export const CREATE_TASK_SUCCESS = "CREATE_TASK_SUCCESS";
export const CREATE_TASK_FAILED = "CREATE_TASK_FAILED";
export const EDIT_TASK_FAILED = "EDIT_TASK_FAILED";
export const CREATE_TASK_PENDING = "CREATE_TASK_PENDING";
